<div class="blue-border">

  <div class="container-card d-flex">
      <mat-card class="card">
          <mat-card-header class="header">
              <mat-card-title>{{"newOrder.confirm.info.title" | translate}}</mat-card-title>
              <mat-card-subtitle>
                  <div>
                      {{"home.orders.productionTimes" | translate}}
                      <a href="https://hecht-contactlinsen.de/wp-content/uploads/Fertigungszeiten_extern.pdf">{{"home.orders.productionTimesLink" | translate}}</a>.
                  </div>
                  <div [innerHtml]='"newOrder.confirm.info.agreement" | translate: { privacyNotice: getPrivacyNoteLink() | async, useCondition: getUseConditionLink() | async}'></div>
              </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content class="d-flex content">
              <div style="display: inline-flex;" *ngIf="isGroupAccount">
                  <form [formGroup]="searchForm" style="margin-top: -6px;">
                      <div style="display: inline-flex">
                          <input placeholder="{{currentUser.account.customerNumber}}" class="form-control parameter-input" [matAutocomplete]="auto" formControlName="searchBar">
                          <button (click)="changeAccount()" class="clear-button"><img src="assets/img/icons/activated.svg" style="width: 30px;"></button>
                      </div>
                          <mat-autocomplete #auto="matAutocomplete">
                              <ng-container>
                                  <mat-option *ngFor="let option of searchResult" [value]="option.customerNumber">
                                      <span>{{ option.customerNumber + ' ' + option.customerName}}</span>
                                  </mat-option>
                              </ng-container>
                          </mat-autocomplete>
                  </form>
              </div>
              <div class="user-info">
                  <b>{{"newOrder.confirm.info.customerName" | translate}}: </b><span>{{currentUser.account.customerName}}</span>
              </div>
              <div class="user-info">
                  <b>{{"newOrder.confirm.info.customerNumber" | translate}}: </b><span>{{currentUser.account.customerNumber}}</span>
              </div>
              <div class="user-info">
                  <b>{{"newOrder.confirm.info.fullName" | translate}}: </b><span>{{currentUser.fullName}}</span>
              </div>
          </mat-card-content>
          <mat-card-actions class="action">
              <button mat-flat-button color="primary" [ngClass]="(isEnglish()) ? 'send-button-en' : 'send-button-de'" (click)="sendOrder()"
                      [disabled]="lensesItems.data.length === 0 && careItems.data.length === 0 && accessoriesItems.data.length === 0">
                {{"newOrder.buttons.send" | translate}}
              </button>
          </mat-card-actions>
      </mat-card>
  </div>

  <div *ngIf="lensesItems.data.length != 0" class="order-table">
      <h1 class="type-item-title">{{"home.orders.lenses" | translate}}</h1>
      <table mat-table [dataSource]="lensesItems" matSort #lensesSort="matSort" class="table-care-accessories-order">

          <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="type-header">{{"newOrder.confirm.cart.type" | translate}}</th>
              <td mat-cell *matCellDef="let row">
                  <img src="assets/img/icons/lenses.svg" matTooltipPosition="above">
              </td>
          </ng-container>

          <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="name-header-lens">{{"newOrder.confirm.cart.name" | translate}}</th>
              <td mat-cell *matCellDef="let row; let i = index">
                  {{row.article.name}}<br>
                  <a href="javascript:void(0)" (click)="editLens(row, i)">{{"newOrder.confirm.cart.edit" | translate}} <fa-icon [icon]="linkIcon"></fa-icon></a>
              </td>
          </ng-container>

          <ng-container matColumnDef="info">
              <th mat-header-cell *matHeaderCellDef class="info-header">{{"newOrder.confirm.cart.info" | translate}}</th>
              <td mat-cell *matCellDef="let row"><span style="white-space: pre-line">{{getInfo(row)}}</span></td>
          </ng-container>

          <ng-container matColumnDef="side">
              <th mat-header-cell *matHeaderCellDef class="side-header">{{"newOrder.confirm.cart.side" | translate}}</th>
              <td mat-cell *matCellDef="let row" style="padding-left: 20px">{{getSide(row)}}</td>
          </ng-container>

          <ng-container matColumnDef="commission">
              <th mat-header-cell *matHeaderCellDef class="commission-header">{{"newOrder.confirm.cart.commission" | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.commission}}</td>
          </ng-container>

          <ng-container matColumnDef="desire-date">
            <th mat-header-cell *matHeaderCellDef class="desire-header">{{"newOrder.confirm.cart.desireDate" | translate}}</th>
            <td mat-cell *matCellDef="let row" style="padding-left: 40px;">
              {{transformDate(row.desireDate)}}
              <img *ngIf="notify(row.desireDate)"
                   src="assets/img/icons/info.svg"
                   [matTooltip]="'newOrder.finalLens.desireDateEqualize' | translate"
                   matTooltipPosition="above"
                   class="small-info">
            </td>
          </ng-container>

          <ng-container matColumnDef="return">
              <th mat-header-cell *matHeaderCellDef class="return-header">{{"newOrder.confirm.cart.return" | translate}}</th>
              <td mat-cell *matCellDef="let row">
                  <img *ngIf="row.isReturn" src="assets/img/icons/revert.svg">
                  <img *ngIf="!row.isReturn" src="assets/img/icons/revert-cross.svg">
              </td>
          </ng-container>

          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions-header" style="padding-right: 0">{{"home.orders.actions" | translate}}</th>
              <td mat-cell *matCellDef="let row" class="actions-row" style="padding-right: 0">
                  <img src="assets/img/icons/delete2.svg"
                       [matTooltip] = "'home.orders.tooltips.delete' | translate "
                       matTooltipPosition="above"
                       (click)="deleteCareAccessoryItem(row)"
                       style="cursor: pointer">
                  <!--<img src="assets/img/icons/delete2.svg"
                       title = "{{'home.orders.tooltips.delete' | translate}}"
                       (click)="deleteCareAccessoryItem(row)"
                       style="cursor: pointer">-->
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsLenses"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsLenses;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" class="paginator-care-accessories-order" #lensesPaginator="matPaginator"></mat-paginator>
  </div>

  <div *ngIf="careItems.data.length != 0" class="order-table">
      <h1>{{"newOrder.equipment.care.title" | translate}}</h1>
      <table mat-table [dataSource]="careItems" matSort #careSort="matSort" class="table-care-accessories-order">

          <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="type-header">{{"newOrder.confirm.cart.type" | translate}}</th>
              <td mat-cell *matCellDef="let row">
                  <img src="assets/img/icons/care.svg" matTooltipPosition="above">
              </td>
          </ng-container>

          <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="name-header" mat-sort-header>{{"newOrder.confirm.cart.name" | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.article.name}}</td>
          </ng-container>

          <ng-container matColumnDef="warning">
              <th mat-header-cell *matHeaderCellDef class="unit-header"></th>
              <td mat-cell *matCellDef="let row" class="unit-row">
                  <div *ngIf="!row.article.electronicOrdering" class="exclamation-mark" matTooltip="{{getExclamationHint()}}" matTooltipPosition="below" matTooltipClass="allow-break">&nbsp;!</div>
              </td>
          </ng-container>

          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef class="unit-header">{{"newOrder.confirm.cart.count" | translate}}</th>
            <td mat-cell *matCellDef="let row" class="unit-row">{{row.count}}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions-header">{{"home.orders.actions" | translate}}</th>
              <td mat-cell *matCellDef="let row" class="actions-row">
                  <img src="assets/img/icons/delete2.svg" [matTooltip]="'home.orders.tooltips.delete' | translate" matTooltipPosition="above" (click)="deleteCareAccessoryItem(row)">
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCareAccessories"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsCareAccessories;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" class="paginator-care-accessories-order" #carePaginator="matPaginator"></mat-paginator>
  </div>

  <div *ngIf="accessoriesItems.data.length != 0" class="order-table">
      <h1 class="type-item-title">{{"newOrder.equipment.accessories.title" | translate}}</h1>
      <table mat-table [dataSource]="accessoriesItems" matSort #accessorySort="matSort" class="table-care-accessories-order">

          <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef class="type-header">{{"newOrder.confirm.cart.type" | translate}}</th>
              <td mat-cell *matCellDef="let row">
                  <img src="assets/img/icons/care.svg" matTooltipPosition="above">
              </td>
          </ng-container>

          <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-header">{{"newOrder.confirm.cart.name" | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.article.name}}</td>
          </ng-container>

          <ng-container matColumnDef="warning">
              <th mat-header-cell *matHeaderCellDef class="unit-header"></th>
              <td mat-cell *matCellDef="let row" class="unit-row">
                  <div *ngIf="!row.article.electronicOrdering" class="exclamation-mark" matTooltip="{{getExclamationHint()}}" matTooltipPosition="below" matTooltipClass="allow-break">&nbsp;!</div>
              </td>
          </ng-container>

          <ng-container matColumnDef="unit">
            <th mat-header-cell *matHeaderCellDef class="unit-header">{{"newOrder.confirm.cart.count" | translate}}</th>
            <td mat-cell *matCellDef="let row" class="unit-row">{{row.count}}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="actions-header">{{"home.orders.actions" | translate}}</th>
              <td mat-cell *matCellDef="let row" class="actions-row">
                  <img src="assets/img/icons/delete2.svg" [matTooltip]="'home.orders.tooltips.delete' | translate" matTooltipPosition="above" (click)="deleteCareAccessoryItem(row)">
              </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCareAccessories"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsCareAccessories;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 7, 10]" showFirstLastButtons color="standart" class="paginator-care-accessories-order" #accessoryPaginator="matPaginator"></mat-paginator>
  </div>

  <mat-card-actions class="action" *ngIf="(lensesItems.data.length + careItems.data.length + accessoriesItems.data.length) >= 5">
    <button mat-flat-button color="primary" [ngClass]="(isEnglish()) ? 'secondary-send-button-en' : 'secondary-send-button-de'" (click)="sendOrder()"
            [disabled]="lensesItems.data.length === 0 && careItems.data.length === 0 && accessoriesItems.data.length === 0">
      {{"newOrder.buttons.send" | translate}}
    </button>
  </mat-card-actions>

</div>
<div class="footer"></div>
